import React, {useState} from "react";
import { useDispatch } from 'react-redux';
import { Link, withRouter } from "react-router-dom";
import { Modal } from 'react-bootstrap';
import {format} from 'date-fns';
import { currentUser } from "../../../../store/selectors/CurrentUserSelector";

const RemboursementListItem = (props) => {
    const { history, facture, currentUser } = props;


    const dispatch = useDispatch();

    const chackbox = document.querySelectorAll(".patient_checkbox input");
    const motherChackBox = document.querySelector(".patient_strg input");
    const chackboxFun = (type) => {
        for (let i = 0; i < chackbox.length; i++) {
            const element = chackbox[i];
            if (type === "all") {
                if (motherChackBox.checked) {
                element.checked = true;
                } else {
                element.checked = false;
                }
            } else {
                if (!element.checked) {
                motherChackBox.checked = false;
                break;
                } else {
                motherChackBox.checked = true;
                }
            }
        }
    };

    const isUserDoctor = () => {
        let profls = currentUser.profils.map((profil) => { return profil.code});
        return profls.includes("MEDCONPRO001");
    }

    const isUserRedactor = () => {
        let profls = currentUser.profils.map((profil) => { return profil.code});
        return profls.includes("REDACPRO001");
    }

    const viewFacture = () => {
        if(isUserDoctor()) {
            history.push('/remboursement-update/'+facture.id);
        }else {
            history.push('/demande-remboursement-update/'+facture.id);
        }
    }

    const printFacture = () => {
        history.push('/remboursement-details/'+facture.id);
    }

    const statusColor = () => {
        if(facture.status === "PENDING") {
            return "text-warning"
        }
        if(facture.status === "Non démarré") {
            return "text-secondary"
        }
        if(facture.status === "COMPLETE") {
            return "text-success"
        }
        if(facture.status === "Expiré") {
            return "text-danger"
        }
        return "text-danger"
    }


    return (
        <tr role="row" className="odd">
            <td className="patient_checkbox">
                <div className="checkbox text-right align-self-center">
                    <div className="custom-control custom-checkbox ">
                    <input
                        type="checkbox"
                        onClick={() => chackboxFun()}
                        className="custom-control-input"
                        id="customCheckBox1"
                        required
                    />
                    <label
                        className="custom-control-label"
                        htmlFor="customCheckBox1"
                    />
                    </div>
                </div>
            </td>
            <td>{facture.id}</td>
            <td>{facture.name}</td>
            <td>{facture.souscripteurName}</td>
            <td>{facture.montantTotal}</td>
            <td>{format(new Date(facture.dateFacturation), 'dd/MM/yyyy')}</td>
            <td>
                <div className="d-flex align-items-center">
                    <span className={statusColor()}>{facture.statusPaiement ? facture.statusPaiement : "Impayée"}</span>
                </div>
            </td>
            <td>{facture.statusPaiement ? format(new Date(facture.datePaiement), 'dd/MM/yyyy') : ''}</td>
            <td className="d-flex justify-content-between align-items-center h100">
                {facture.statusPaiement === "PENDING" && <button className="btn btn-primary shadow btn-xs sharp mr-2"
                    onClick={viewFacture}
                >
                    <i className="fa fa-pencil"></i>
                </button>}

                <button className="btn btn-warning shadow btn-xs sharp mr-2"
                    onClick={(e) => printFacture()}
                >
                    <i className="la la-print"></i>
                </button>
            </td>
        </tr>
    );
};

export default withRouter(RemboursementListItem);